/* modal-loading-error.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./modal-loading-error.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect } from 'react';
import { cx } from '@compiled/react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
import { SpotErrorSearch } from '../../../common/ui/spot/error-state/search';
import { loadingErrorMessages } from './messages';
var styles = {
  errorContainerStyles: "_zulp1ejb _4cvr1h6o _6a6z1h6o _1wpz1h6o _10fp1h6o _1e0c11p5",
  errorContainerStylesNew: "_zulp1ejb _4cvr1h6o _6a6z1h6o _1wpz1h6o _10fp1h6o _1e0c11p5 _ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv _p12f1kdj",
  errorMessageContainerStylesOld: "_zulpu2gc _4cvr1h6o _6a6z1h6o _1e0c11p5",
  errorMessageContainerStyles: "_zulppxbi _4cvr1h6o _6a6z1h6o _1e0c11p5 _y3gn1h6o"
};
export var ModalLoadingError = function ModalLoadingError(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.checkConnection) : _ref$errorMessage,
    onRefresh = _ref.onRefresh;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  useEffect(function () {
    fireEvent('ui.error.shown', {
      reason: 'network'
    });
  }, [fireEvent]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(fg('platform-linking-visual-refresh-sllv') ? styles.errorContainerStylesNew : styles.errorContainerStyles),
    testId: "datasource-modal--loading-error"
  }, /*#__PURE__*/React.createElement(SpotErrorSearch, {
    size: 'xlarge',
    alt: ""
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: cx(fg('platform-linking-visual-refresh-sllv') ? styles.errorMessageContainerStyles : styles.errorMessageContainerStylesOld)
  }, fg('platform-linking-visual-refresh-sllv') ? /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "large",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.unableToLoadResults)) : /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.unableToLoadResultsOld)), fg('platform-linking-visual-refresh-sllv') ? /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "medium"
  }, errorMessage) : /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, errorMessage), onRefresh && fg('platform-linking-visual-refresh-sllv') && /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: onRefresh,
    testId: "datasource-modal--loading-error-refresh"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.refresh))));
};